import { render, staticRenderFns } from "./AddUserPage.vue?vue&type=template&id=744b00db&"
import script from "./AddUserPage.vue?vue&type=script&lang=js&"
export * from "./AddUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports